import Btns from './Btns';
export default Btns;


// WEBPACK FOOTER //
// ./src/index.js